(() => {
    const mq = matchMedia('(hover: hover) and (pointer: fine)');
    if (!mq.matches) return;

    function initZoom(el) {
        const baseImg =
            el.querySelector('picture img') ||
            el.querySelector('img:not(.pdp-zoom__overlay)');
        if (!baseImg) return;

        const zoomFactor = parseFloat(el.dataset.zoomFactor || '2.2');
        const pad = parseFloat(
            el.dataset.zoomPadding || el.dataset.zoomPaddingEnter || '5'
        );

        let hot = el.querySelector('.pdp-zoom__hotzone');
        if (!hot) {
            hot = document.createElement('div');
            hot.className = 'pdp-zoom__hotzone';
            el.appendChild(hot);
        }
        const setInsets = (p) => {
            hot.style.top = p + '%';
            hot.style.right = p + '%';
            hot.style.bottom = p + '%';
            hot.style.left = p + '%';
        };
        setInsets(pad);

        let overlay = el.querySelector('.pdp-zoom__overlay');
        if (!overlay) {
            overlay = document.createElement('img');
            overlay.className = 'pdp-zoom__overlay';
            overlay.alt = '';
            overlay.decoding = 'async';
            overlay.loading = 'eager';
            el.appendChild(overlay);
        }
        overlay.src = baseImg.currentSrc || baseImg.src;

        let hiResUpgraded = false;
        function upgradeToHiRes() {
            const hi = el.dataset.zoomSrc;
            if (!hi || hiResUpgraded) return;
            const pre = new Image();
            pre.src = hi;
            pre.onload = () => {
                overlay.src = hi;
                hiResUpgraded = true;
            };
        }

        function setZoom(on) {
            if (on) {
                el.style.setProperty('--zoom', String(zoomFactor));
                el.classList.add('is-zoomed');
                upgradeToHiRes();
            } else {
                el.classList.remove('is-zoomed');
            }
        }

        function onMove(e) {
            const rect = el.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width) * 100;
            const y = ((e.clientY - rect.top) / rect.height) * 100;
            el.style.setProperty('--x', `${x}%`);
            el.style.setProperty('--y', `${y}%`);
        }

        // The gallery's prev/next arrows overlap the hotzone. product.css now
        // stacks them above it, so normally the pointer never reaches here while
        // it is on an arrow; this is the backstop for when it does (a stacking
        // change, a slide scrolling under a stationary pointer) — an arrow under
        // the pointer means no zoom, so the arrow is always usable.
        function overNavButton(e) {
            const top = document.elementFromPoint(e.clientX, e.clientY);
            return !!(top && top !== hot && top.closest('.carousel__nav-button'));
        }

        hot.addEventListener('mouseenter', (e) => {
            if (overNavButton(e)) { setZoom(false); return; }
            onMove(e);
            setZoom(true);
        });
        hot.addEventListener('mousemove', (e) => {
            if (overNavButton(e)) { setZoom(false); return; }
            if (!el.classList.contains('is-zoomed')) setZoom(true);
            onMove(e);
        });
        hot.addEventListener('mouseleave', () => setZoom(false));
        el.addEventListener('mouseleave', () => setZoom(false));
    }

    document.querySelectorAll('[data-zoom]').forEach(initZoom);

    const obs = new MutationObserver((mutations) => {
        for (const m of mutations) {
            for (const node of m.addedNodes || []) {
                if (!(node instanceof Element)) continue;
                if (node.matches?.('[data-zoom]')) initZoom(node);
                node.querySelectorAll?.('[data-zoom]').forEach(initZoom);
            }
        }
    });
    obs.observe(document.body, { childList: true, subtree: true });
})();

